import React, { useContext, useEffect, useState } from 'react'
import { Outlet } from 'react-router-dom';
import Axios from './utils/axios';
import AuthContext from './utils/AuthContext';



const MainLayout = () => {
  const { user } = useContext(AuthContext);
  // const [user, setUser] = useState({});


  // useEffect(() => {
  //   Axios.get('/')
  //   .then(res => {
  //     console.log(res.data);
  //     setUser(res.data);
  //   })
  //   .catch(err => console.log(err))
  // },[])


  return (
    <>
      <Outlet context={user}/>
    </>
  )
}

export default MainLayout;